// extracted by mini-css-extract-plugin
export default {"NewClientDialog":"NewClientDialog_NewClientDialog__4mJ+E"};